import { render, staticRenderFns } from "./Atrato.vue?vue&type=template&id=e31134a6&scoped=true"
import script from "./Atrato.vue?vue&type=script&lang=js"
export * from "./Atrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31134a6",
  null
  
)

export default component.exports